import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
   } from '@angular/common/http';
   
   import { Observable, throwError } from 'rxjs';
   import { retry, catchError, map, tap } from 'rxjs/operators';
   import { Injectable } from '@angular/core';
   import { EventsService } from './services/events.service';
   import { AuthService } from './services/auth.service';
   import { AlertButton, AlertController } from '@ionic/angular';
   import { TranslateService } from '@ngx-translate/core';
   import { Platform, NavController, ModalController } from '@ionic/angular';
   import { DateUtilsService } from './services/date-utils.service';
   import { Router, NavigationStart, NavigationEnd } from '@angular/router';
   import { environment } from './../environments/environment';
   
   export class HttpError{
       static BadRequest = 400;
       static Unauthorized = 401;
       static Forbidden = 403;
       static NotFound = 404;
       static TimeOut = 408;
       static Conflict = 409;
       static InternalServerError = 500;
   }
   
   @Injectable()
   export class HttpErrorInterceptor implements HttpInterceptor {
   
     constructor(
       public dateUtils: DateUtilsService,
       public events: EventsService,
       private authService: AuthService,
       public alertController: AlertController,
       private router: Router,
       private translate: TranslateService,
       private navCtrl: NavController) { }
   
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const isExternal = request.url.startsWith('http') && !request.url.includes('sonespacesante.fr') && !request.url.includes('localhost');
      if(!request.url.includes('://media.') && !isExternal) {
        request = request.clone({ headers: request.headers.append('APPVersion', environment.APP_VERSION) });
      }
      return next.handle(request)
      .pipe(
        retry(0),
        map(event => {
            if (event instanceof HttpResponse)
            {
              if (event.status >= 100 && event.status <= 400) {
                if(event['body']['__notifications__']) {
  
                  for(var notif in event['body']['__notifications__']) {
                    event['body']['__notifications__'][notif]['date'] = this.dateUtils.toStringWithoutYearWithoutSeconds(this.dateUtils.fromString(event['body']['__notifications__'][notif]['date']))
                  }
  
                  this.authService.setNotifications(event['body']['__notifications__'])
                }
                this.events.publish('NetworkSuccess');
              }
              else
                this.events.publish('NetworkSuccess');
            }
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
          switch (error.status) {
            case HttpError.Unauthorized:
              console.log('error disconnect')
              console.log(error.status)
              console.log(error.error.message)
              console.log(JSON.stringify(error.error))
              console.error(error.url);
              // var header = this.translate.instant("Access error");
              // var msg = this.translate.instant("Due to a technical error you have been disconnected, please reconnect.");
  
              // (async() => {
              //   const alert = await this.alertController.create({
              //     header: header,
              //     message: msg,
              //     buttons: ['OK']
              //   });
              //   await alert.present();
              // })();
  
              this.authService.logoutDeleteLocalData();
              this.authService._statusChange$.next(false);
              this.router.navigate(['login']);
              break;
            case HttpError.Forbidden:
  
              var header = this.translate.instant("Forbidden access");
              var msg = this.translate.instant("Access to this page is prohibited.");
              let buttons: (string | AlertButton)[] = ['OK']
              if(error.error.msgCode == 'AnimalForbiddenCantAddMoreAnimals') {
                header = this.translate.instant("Limit reached for this species!");
                msg = this.translate.instant("You have reached the maximum number of animals of this species authorized by your current subscription. To add this animal, please go to a higher plan.");
                buttons = [{
                  text: this.translate.instant("Cancel"),
                  role: 'cancel'
                }, {
                  text: this.translate.instant("See subscriptions"),
                  role: 'upgrade',
                  handler: () => {
                    this.router.navigate(['/organization-subscription']);
                  }
                }]
              } else if(error.error.msgCode == 'LitterForbiddenCantAddMoreLitters') {
                header = this.translate.instant("Limit of reach reached for the year!");
                msg = this.translate.instant("You have reached the limit of the maximum number of litters for this year. To add this range, please go to a higher subscription.");
                buttons = [{
                  text: this.translate.instant("Cancel"),
                  role: 'cancel'
                }, {
                  text: this.translate.instant("See subscriptions"),
                  role: 'upgrade',
                  handler: () => {
                    this.router.navigate(['/organization-subscription']);
                  }
                }]
              }
              
              if (error.error.msgCode == 'AnimalForbiddenCantAddMoreAnimals' || error.error.msgCode == 'LitterForbiddenCantAddMoreLitters') {
                (async() => {
                  const alert = await this.alertController.create({
                    header: header,
                    message: msg,
                    buttons: buttons
                  });
                  await alert.present();
                })();
              }
  
              //window.location.href = '/http-error-forbidden';
              break;
            //case HttpError.BadRequest:
            case HttpError.NotFound:
            case HttpError.TimeOut:
            case HttpError.Conflict:
            case HttpError.InternalServerError:
              console.log(error)
  
              // var header = this.translate.instant("Access error");
              // var msg = this.translate.instant("An error has occurred, our teams have been notified and will intervene quickly.");
  
              // (async() => {
              //   const alert = await this.alertController.create({
              //     header: header,
              //     message: msg,
              //     buttons: ['OK']
              //   });
              //   await alert.present();
              // })();
  
              //window.location.href = '/http-error-generic';
              break;
            case 0:
              console.log('Network error (offline or timeout)');
              // On ne déconnecte pas, l'application gère la synchronisation hors-ligne
              break;
            case undefined:
              break;
            default:
              break;
          }
          return throwError(error);
        })
      )
    }
   }
   
   
   